/* CUFF – Warenkorb 2.0: Versand- und Geschenkstatus + Preis im Kassen-Button */
(function(){
  var CHECK='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#141414" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12l5 5L20 6"></path></svg>';
  function money(c){
    try{ if(window.theme&&theme.Currency&&theme.settings) return theme.Currency.formatMoney(c, theme.settings.moneyFormat); }catch(e){}
    return (c/100).toFixed(2).replace('.',',')+' €';
  }
  function esc(s){return String(s).replace(/[&<>"]/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch];});}
  function render(cart){
    if(!cart) return;
    var total=cart.total_price||0;
    document.querySelectorAll('[data-cuff-total]').forEach(function(el){el.innerHTML=money(total);});
    var sr=document.querySelector('[data-cuff-shiprow]');
    if(sr){ var fr=parseInt(sr.dataset.free||'0',10), sv=sr.querySelector('[data-cuff-shipval]');
      if(fr>0&&sv){ sv.innerHTML = total>=fr ? esc(sr.dataset.tFree) : money(parseInt(sr.dataset.fee||'0',10)); } }
    var tl=document.querySelector('[data-cuff-total-label]');
    if(tl&&sr){ var f2=parseInt(sr.dataset.free||'0',10); tl.textContent = (f2>0 && total>=f2) ? tl.dataset.tTotal : tl.dataset.tSubtotal; }
    var box=document.querySelector('[data-cuff-status]'); if(!box) return;
    box.hidden = !cart.item_count;
    var free=parseInt(box.dataset.free||'0',10), gift=parseInt(box.dataset.gift||'0',10);
    var ship=box.querySelector('[data-cuff-ship]'), grow=box.querySelector('[data-cuff-giftrow]');
    var bar=box.querySelector('[data-cuff-bar]'), fill=box.querySelector('[data-cuff-bar-fill]');
    if(free>0){
      ship.innerHTML = total>=free ? CHECK+'<span>'+esc(box.dataset.tShipFree)+'</span>'
        : '<span>'+esc(box.dataset.tShipRemaining).replace('[amount]','<strong>'+money(free-total)+'</strong>')+'</span>';
    } else { ship.innerHTML='<span>'+esc(box.dataset.tShipIntl)+'</span>'; }
    if(gift>0){
      if(total>=gift){ grow.innerHTML=CHECK+'<span>'+esc(box.dataset.tGiftUnlocked)+'</span>'; bar.hidden=true; }
      else{ grow.innerHTML='<span>'+esc(box.dataset.tGiftRemaining).replace('[amount]','<strong>'+money(gift-total)+'</strong>')+'</span>'; bar.hidden=false; fill.style.width=Math.max(4,Math.round(total/gift*100))+'%'; }
    } else { grow.innerHTML=''; bar.hidden=true; }
  }
  function refresh(){ fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(render).catch(function(){}); }
  document.addEventListener('cart:updated',function(e){ if(e.detail&&e.detail.cart) render(e.detail.cart); else refresh(); });
  ['cart:open','ajaxProduct:added','drawerOpen.CartDrawer'].forEach(function(ev){ document.addEventListener(ev,function(){ setTimeout(refresh,150); }); });
  if(document.readyState!=='loading') refresh(); else document.addEventListener('DOMContentLoaded',refresh);

  /* Fix: Bestseller-Block (Sidekick) öffnet nur den Drawer, ohne ihn neu aufzubauen -> leerer Warenkorb sichtbar.
     Bei jedem Öffnen den Inhalt neu laden. */
  document.addEventListener('cart:open',function(){ document.dispatchEvent(new CustomEvent('cart:build')); });

  /* Fix Produktformulare: sticky-atc.liquid hatte einen jQuery-Submit an JEDES Produktformular gebunden.
     Folgen: doppelt im Warenkorb (wo das Theme selbst auch hinzufügt) bzw. "nichts passiert"
     (jQuery wertet die Antwort von /cart/add.js als Script aus -> Fehler, Warenkorb aktualisiert sich nicht).
     Neu: alte Handler entfernen; ein sauberer Handler greift nur, wenn das Theme das Formular nicht selbst verarbeitet. */
  function unbindLegacy(){
    try{ if(window.jQuery){ jQuery('form.product-single__form').off('submit'); } }catch(e){}
  }
  function onSubmit(e){
    if(e.defaultPrevented) return;            /* Theme (Impulse) kümmert sich bereits */
    var form=e.currentTarget; e.preventDefault();
    var btn=form.querySelector('[type=submit]');
    if(form.dataset.cuffBusy==='1') return; form.dataset.cuffBusy='1';
    if(btn){ btn.classList.add('btn--loading'); btn.setAttribute('aria-busy','true'); }
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:new FormData(form)})
      .then(function(r){ return r.json().then(function(d){ if(!r.ok) throw d; return d; }); })
      .then(function(item){ document.dispatchEvent(new CustomEvent('ajaxProduct:added',{detail:{product:item,addToCartBtn:btn}})); })
      .catch(function(err){ try{ console.warn('CUFF add to cart', err); }catch(x){} HTMLFormElement.prototype.submit.call(form); })
      .then(function(){ form.dataset.cuffBusy=''; if(btn){ btn.classList.remove('btn--loading'); btn.removeAttribute('aria-busy'); } });
  }
  function bindForms(){
    unbindLegacy();
    document.querySelectorAll('form.product-single__form').forEach(function(f){
      if(f.dataset.cuffBound) return; f.dataset.cuffBound='1'; f.addEventListener('submit',onSubmit);
    });
  }
  if(document.readyState!=='loading') unbindLegacy(); else document.addEventListener('DOMContentLoaded',unbindLegacy);
  if(document.readyState==='complete') bindForms(); else window.addEventListener('load',function(){ setTimeout(bindForms,0); });
})();
